import { render, staticRenderFns } from "./GImageFormInput.vue?vue&type=template&id=625dab96&scoped=true&"
import script from "./GImageFormInput.vue?vue&type=script&lang=ts&"
export * from "./GImageFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GImageFormInput.vue?vue&type=style&index=0&id=625dab96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625dab96",
  null
  
)

export default component.exports